(ns practitest.frontend.common.tooltip
  (:require
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.tooltip :as tooltip]))

(defn info-circle-tooltip
  ([tooltip-body] (info-circle-tooltip tooltip-body {}))
  ([tooltip-body {:keys [tag class trigger]
                  :or   {tag :span}}]
   [tooltip/mux-tooltip
    (cond-> {} trigger (assoc :trigger trigger))
    tooltip-body
    (fn [props]
      [tag
       (cond-> (assoc props :class "icon-holder")
         class (update :class str " " class))
       [icons/mux-info-circle]])]))